/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Editor/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaTextarea from 'DesignSystem/TysiaTextarea/index'
import TysiaTextareaContent from 'DesignSystem/TysiaTextarea/TysiaTextareaContent/index'
import TysiaTextareaField from 'DesignSystem/TysiaTextarea/TysiaTextareaField/index'



/** @type {import('Simple/types.js').View} */
export default function Editor({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Editor",
  onChange,
  isSubmitting
  
}) {
let messageComposeMessageValueData = fromData.useDataValue({ viewPath,
context: 'message_compose',
path: 'message',
})
let messageComposeMessageChangeData = fromData.useDataChange({ viewPath,
context: 'message_compose',
path: 'message',
})
let messageComposeMessageIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'message_compose',
})
let threadTypeValueData = fromData.useDataFormat({ viewPath,
context: 'thread',
path: 'type',
format: fromFormat.isSmsMaxLength,
})
let threadTypeValueData1 = fromData.useDataFormat({ viewPath,
context: 'thread',
path: 'type',
format: fromFormat.isInAppMessage,
})
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let dtTypographyLineheightM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.lineHeight.m'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 autoFocus={true}
 backgroundColor="#fff"
 borderColor={dtColorsNeutral200}
 borderStyle="solid"
 borderWidth={2}
 fontSize={dtTypographyFontsizeM}
 lineHeight={dtTypographyLineheightM}
 fontWeight={300}
 minHeight={30}
 maxHeight={500}
 paddingLeft={10}
 paddingTop={8}
 marginTop={0}
 marginBottom={dtSpaceXs}
 resize="none"
 data="message_compose.message"
 value={messageComposeMessageValueData}
 onChange={messageComposeMessageChangeData}
 disabled={messageComposeMessageIsSubmittingData}
 data="thread.type"
 format="/Data/format.js isSmsMaxLength"
 maxLength={threadTypeValueData}
 data="thread.type"
 format="/Data/format.js isInAppMessage"
 placeholder={threadTypeValueData1}
>
{childProps => (
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
>
{childProps => (
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
/>
)}
</TysiaTextareaContent>
)}
</TysiaTextarea>
{children}
</React.Fragment>)
}